import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { WhatsAppFab } from './components/layout/WhatsAppFab';
import { Home } from './pages/Home';
import { Solutions } from './pages/Solutions';
import { LogisticsSupplyChain } from './pages/LogisticsSupplyChain';
import { Transport } from './pages/Transport';
import { ControlTower } from './pages/ControlTower';
import { FacilityManagement } from './pages/FacilityManagement';
import { Hse } from './pages/Hse';
import { Sustainability } from './pages/Sustainability';
import { Technology } from './pages/Technology';
import { Industries } from './pages/Industries';
import { Clients } from './pages/Clients';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { NotFound } from './pages/NotFound';
function ScrollManager() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0
    });
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="4wvhonpuufq">
      <ScrollManager data-id="element-1" data-mp="5gfdawxfswe" />
      <a href="#contenido" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:bg-brand-700 focus:px-4 focus:py-2 focus:text-sm focus:text-white" data-id="element-2" data-mp="82j0zgp5o9c">
        Ir al contenido principal
      </a>
      <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-3" data-mp="38kqafz2efxuo">
        <Header data-id="element-4" data-mp="3dkl5met7j9lj" />
        <main id="contenido" className="flex-1" data-id="element-5" data-mp="3dl4l7ovdxlwe">
          <Routes data-id="element-6" data-mp="3dirw8rr7mb9u">
            <Route path="/" element={<Home data-id="element-8" data-mp="nwc23tmizxws" />} data-id="element-7" data-mp="nvj3jfxq0epq" />
            <Route path="/soluciones" element={<Solutions data-id="element-10" data-mp="nxwx1kcr5iv6" />} data-id="element-9" data-mp="nur8c681cizz" />
            <Route path="/soluciones/logistica-supply-chain" element={<LogisticsSupplyChain data-id="element-12" data-mp="ssstcwp0use3" />} data-id="element-11" data-mp="su45bjsmf6ga" />
            <Route path="/soluciones/transporte-distribucion" element={<Transport data-id="element-14" data-mp="34ndtz6vvc0b" />} data-id="element-13" data-mp="35yq6nee9s31" />
            <Route path="/soluciones/control-tower" element={<ControlTower data-id="element-16" data-mp="3ubzw6hji5vht" />} data-id="element-15" data-mp="3uct0zcywiaxb" />
            <Route path="/soluciones/facility-management" element={<FacilityManagement data-id="element-18" data-mp="d3mmhhrnf7nb" />} data-id="element-17" data-mp="3uf5ijp0qyj9u" />
            <Route path="/soluciones/hse" element={<Hse data-id="element-20" data-mp="851lvh8hilyc" />} data-id="element-19" data-mp="d2l7x3bfc30u" />
            <Route path="/soluciones/sustentabilidad" element={<Sustainability data-id="element-22" data-mp="83qdf443gq0w" />} data-id="element-21" data-mp="86mc4unrniqe" />
            <Route path="/tecnologia" element={<Technology data-id="element-24" data-mp="3glwfs77b0w0a" />} data-id="element-23" data-mp="3gklb8561bk84" />
            <Route path="/industrias" element={<Industries data-id="element-26" data-mp="3bn2z65wq0ovw" />} data-id="element-25" data-mp="3bmbdpnwu87jc" />
            <Route path="/clientes" element={<Clients data-id="element-28" data-mp="3bkgtycxaylgu" />} data-id="element-27" data-mp="3bnuvjiy56qn8" />
            <Route path="/nosotros" element={<About data-id="element-30" data-mp="3qcr0360zplj3" />} data-id="element-29" data-mp="3qbpq74vpn52y" />
            <Route path="/contacto" element={<Contact data-id="element-32" data-mp="3lkr2hk8e74po" />} data-id="element-31" data-mp="3qdajysa7ajzr" />
            <Route path="*" element={<NotFound data-id="element-34" data-mp="3lj6aa19jvxuz" />} data-id="element-33" data-mp="3ljg0npyic717" />
          </Routes>
        </main>
        <Footer data-id="element-35" data-mp="2xu3ku78od0px" />
        <WhatsAppFab data-id="element-36" data-mp="2xtlq5f1nuuk4" />
      </div>
    </BrowserRouter>;
}